import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay } from "@fortawesome/free-solid-svg-icons";
import VideoDownloadButton from "../video-download-button";

const PLAYBACK_SPEEDS = [1, 1.5, 2];

export default function AthleteMeasurementVideoViewer({
  title,
  videoUrls = [],
  linkText = "Overhead Squat Video",
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const videoRef = useRef(null);
  const videoElementsRef = useRef([]);

  useEffect(() => {
    videoElementsRef.current.forEach((video) => {
      if (video) {
        video.defaultPlaybackRate = playbackRate;
        video.playbackRate = playbackRate;
      }
    });
  }, [playbackRate, isOpen]);

  const openModal = () => {
    setPlaybackRate(1);
    setIsOpen(true);
  };
  const closeModal = () => {
    if (videoRef.current) {
      try {
        videoRef.current.pause();
      } catch {}
    }
    setIsOpen(false);
  };

  return (
    <>
      <div className="pt-0.5 flex items-center">
        <FontAwesomeIcon
          icon={faCirclePlay}
          className={`text-xl pr-2 ${
            videoUrls.length > 0
              ? "text-blue-600 cursor-pointer"
              : "text-gray-400 cursor-not-allowed"
          }`}
          onClick={videoUrls.length > 0 ? openModal : undefined}
        />
        <span className="text-[14px] text-gray-600 font-normal ">
          {linkText}
        </span>
        {isOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-black opacity-50" />
            <div className="bg-white rounded-lg shadow-lg z-50 w-full max-w-5xl min-h-[auto] lg:min-h-[500px] p-4 m-2 overflow-y-auto">
              <div className="flex justify-between items-center mb-1">
                <div className="text-lg font-bold text-gray-800 flex">
                  {title}
                  <div className="pl-16 font-normal">
                    {videoUrls.length > 0 && (
                      <VideoDownloadButton url={videoUrls[0]} />
                    )}
                    {videoUrls.length > 0 && (
                      <div className="inline-flex ml-2 rounded border border-gray-300 overflow-hidden divide-x divide-gray-300 align-middle">
                        {PLAYBACK_SPEEDS.map((speed) => (
                          <button
                            key={speed}
                            onClick={() => setPlaybackRate(speed)}
                            className={`px-3 py-1 text-sm ${
                              playbackRate === speed
                                ? "bg-blue-50 text-blue-700 font-medium"
                                : "bg-white text-gray-600 hover:bg-gray-100 hover:text-black"
                            }`}
                          >
                            {speed}x
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <button
                  onClick={closeModal}
                  className="text-gray-600 hover:text-black text-xl"
                >
                  ✕
                </button>
              </div>
              <div className="flex flex-wrap gap-4 justify-center pt-2 bg-black">
                {videoUrls.map((url, idx) => (
                  <div
                    key={idx}
                    className="w-full overflow-hidden flex justify-center"
                  >
                    <video
                      ref={(element) => {
                        videoRef.current = element;
                        videoElementsRef.current[idx] = element;
                      }}
                      src={url}
                      controls
                      style={{
                        borderRadius: "0px",
                        backgroundColor: "#000",
                        objectFit: "contain",
                        height: "520px",
                      }}
                    ></video>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
